import { COMP_LOADER_TIMEOUT } from "common_assets/Util";
import { CommonLoadingHandler } from "components/LoadingComponent/LoadingHelper";
import { Route, Switch } from "react-router-dom";
import React from "react";
import { getSetOrgId, getUserObject} from "common_assets/CLStorage/CLStorage";
import AppURL from "common_assets/URL";
import Loadable from "react-loadable";
import {SurfaceBackground, SurfaceContext} from "azure-devops-ui/Surface";

const LoginWithLodable = Loadable({
  loader: () => import("views/Login/Login"),
  loading: CommonLoadingHandler,
  timeout: COMP_LOADER_TIMEOUT
});

const MainWithLodable = Loadable({
  loader: () => import("views/Main/Main"),
  loading: CommonLoadingHandler,
  timeout: COMP_LOADER_TIMEOUT
});

class App extends React.Component {

  public componentDidMount() {
    const userObj = getUserObject();
    getSetOrgId();
    if (!userObj) {
      window.location.href =window.location.origin +"#" + AppURL.LOGIN_URL;
      return;
    }
  }

  public render() {
    return (
        <SurfaceContext.Provider value={{ background: SurfaceBackground.neutral }}>
          <Switch>
            <Route path={AppURL.LOGIN_URL} component={LoginWithLodable} />
            <Route path={AppURL.ROOT_PATH} component={MainWithLodable} />
          </Switch>
        </SurfaceContext.Provider>
    );
  }
}

export default App;


